import Swiper from 'swiper';
import { add_swiper_class, swiper_destroy } from '@cabourg/js/tools/swiper';
import 'jquery-match-height/dist/jquery.matchHeight-min';
import Utils from '@cabourg/js/services/utils';

export default class WpetListAside {
    
    constructor()
    {
        WpetListAside.view_mode();
        WpetListAside.slider();
        WpetListAside.match_height();
        WpetListAside.filters();
        WpetListAside.link_offer();
        WpetListAside.offer_meta_mobile();
        WpetListAside.no_booking_offers();
        WpetListAside.initialize_trigger();
    }
    
    static view_mode()
    {
        const trigger  = '[data-trigger="wpet-mode"]',
              $element = $( '[data-id="wpet-list"]' );
        
        if ( trigger.length > 0 ) {
            $( document ).on( 'click', trigger, function ( e ) {
                e.preventDefault();
                
                let mode = $( this ).attr( 'data-wpet-switch-mode' );
                $element.attr( 'data-wpet-current-mode', mode );
                window.wpet_map_object.mapObject.resize();
                
                $( document ).trigger( 'wpet_change_mode' );
            } );
        }
    }
    
    static slider()
    {
        const slider         = '[data-id="wpet-offer-slider"]',
            slider_wrapper = '[data-id="wpet-offer-slider-wrapper"]',
            slider_item    = '[data-id="wpet-offer-slider-item"]';

        let swiper_offer;

        if ( $( slider ).length > 0 ) {

            $( slider ).each( function () {

                let slider_elements = $( this ).find( slider_item );

                if ( $( slider_elements ).length > 1 ) {

                    add_swiper_class( $( slider ), $( slider_wrapper ), $( slider_item ) );

                    swiper_offer = new Swiper( $( this ), {
                        mousewheel: {
                            forceToAxis: true,
                            preventClicks: false,
                        },
                        navigation: {
                            nextEl: '[data-trigger="swiper-next"]',
                            prevEl: '[data-trigger="swiper-prev"]',
                        },
                    } );
                }
            } );
        }
    }
    
    static match_height()
    {
        const $item = $( '[data-mh]' );
        
        if ( $item.length > 0 ) {
            $item.matchHeight();
        }
    }
    
    static filters()
    {
        const trigger  = '[data-trigger="wpet-list-filters-button"]',
              close    = '[data-trigger="wpet-list-filters-close"]',
              $element = $( '[data-id="wpet-list-filters"]' );
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.css( 'right', '0%' );
            $('body').toggleClass('wpetFiltersOpen');
        } );
        
        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.css( 'right', '-100%' );
            $('body').toggleClass('wpetFiltersOpen');
        } );
    }
    
    static link_offer()
    {
        const trigger = '[data-trigger="wpet-click"]';
        
        if ( trigger.length > 0 ) {
            $( document ).on( 'click', trigger, ( e ) => {
                if ( !$( e.target ).hasClass( 'slider-arrow' ) ) {
                    window.location = $( e.currentTarget ).parents( '[data-id="wpet-offer"]' ).find( '[data-id="wpet-offer-link"]' ).attr( 'href' );
                }
            } );
        }
    }
    
    static number_results( data )
    {
        const $element = $( '[data-id="wpet-list-total-offer"]' );
        $element.text( data.total_global );
    }
    
    static offer_meta_mobile()
    {
        const trigger  = '[data-trigger="wpet-offer-mobile-button"]',
              element = '[data-id="wpet-offer-mobile-list"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $( this ).parents( '[data-id="wpet-offer"]' ).find( element ).toggle();
        } );
    }
    
    static form_select()
    {
        $( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
    }
    
    static back_to_top()
    {
        $( 'html, body' ).animate( {
                                       scrollTop: $( '[data-id="wpet-list"]' ).offset().top
                                   }, 300 );
    }

    static no_booking_offers()
    {
        let no_offer_booking_online = false;
        let count_booking_offers    = 0;
        $( '[data-id="wpet-no-booking-message"]' ).remove();

        $.each( $( '.wpetOffer' ), function ( i, e ) {
            if (
                ( 0 === $( this ).find( '.wpetOfferThumbnailPrice--available' ).length) &&
                ( false === $( this ).hasClass( 'wpetContextualBlock' ) ) &&
                (0 === $( '[data-id="wpet-no-booking-message"]' ).length)
            ) {

                if ( 0 === i ) {
                    no_offer_booking_online = true;
                }

                if ( no_offer_booking_online == false ) {
                    $( '<div data-id="wpet-no-booking-message" class="wpetOfferNoBookingMessage">' + Theme.translate.wpet_no_booking + '</div>' ).insertBefore( $( this ) );
                    return false;
                }
            }

            if (
                ( $( this ).find( '.wpetOfferThumbnailPrice--available' ).length > 0) ||
                ( $( this ).hasClass( 'wpetContextualBlock' ) === true)
            ) {
                count_booking_offers++;
            }

        } );

        if ( $( '[data-wpet-search="martetplace"]' ).length > 0 && ($('input[name="marketplace_search[startdate]"]').val() != '') ) {
            if ( no_offer_booking_online == true && count_booking_offers == 0 ) {
                $( '.wpetListResultsOffers' ).prepend( '<div data-id="wpet-no-booking-message" class="wpetOfferNoBookingMessage">' + Theme.translate.wpet_no_booking + '</div>' );
            }
        }
    }

    static marketplace_tooltip_enable()
    {
        if ( $( '[data-wpet-search="martetplace"]' ).length > 0 ) {
            if ( typeof window.IRIS.wpet_marketplace !== 'undefined' ) {
                window.IRIS.wpet_marketplace.tooltip_enable = true;
            }
        }
    }

    static initialize_trigger()
    {
        $( document ).on( 'wpet_ajax_build', ( e, data ) => {
            WpetListAside.form_select();
            WpetListAside.slider();
            Utils.lazy();
            Utils.bootstrap();
            WpetListAside.match_height();
            WpetListAside.back_to_top();
            WpetListAside.number_results( data );
            WpetListAside.no_booking_offers();
        } );

        $( document ).on( 'wpet_change_mode', () => {
            swiper_destroy( '[data-id="wpet-offer-slider"]' );
            WpetListAside.slider();
            WpetListAside.match_height();
            WpetListAside.back_to_top();
        } );

        $( document ).on( 'wpet_map_ready', () => {
            WpetListAside.marketplace_tooltip_enable();
        });
    }
};